<stages-auto-complete-search
	#autoComplete
	[placeholder]="'process.element.quickAssign.select.dependentElementPlaceholder' | translate"
	[query]="getSearchQuery()"
	[searchResultTemplate]="searchResultTemplate"
	(submitted)="selectItemCallback($event)"
	[dropDownClass]="'margin-reduced-h'"
	[inputIconClasses]="getInputIconClasses()"
	[isInSubordinatedElementsMode]="!!this.dependentElementContainer"
	(cancelled)="cancel()"
	[backButtonActive]="false"
	[maxSearchTermLength]="255"
>
	<ng-template #searchResultTemplate let-item>
		<i class="ico" [ngClass]="getIconClassesAndCheckForDependentType(item)"></i>
		<ng-container *ngIf="!item.isNew">
			<p *ngIf="!item.isNew" class="has-chevron-right">
				{{ item.label }}
			</p>
		</ng-container>
		<p *ngIf="item.isNew" [translate]="'search.autoComplete.create'" [translateParams]="{ ARG0: item.label }"></p>
	</ng-template>
</stages-auto-complete-search>
